export function parseTimeSpan(value: string) {
  const [timePart, fractionPart] = value.split('.')
  const parts = timePart.split(':').map(Number)

  if (parts.length !== 3 || parts.some((part) => Number.isNaN(part))) {
    return 0
  }

  const [hours, minutes, seconds] = parts
  const fraction = fractionPart ? Number(`0.${fractionPart}`) : 0
  return hours * 3600 + minutes * 60 + seconds + (Number.isNaN(fraction) ? 0 : fraction)
}

export function formatTimeSpan(value: string) {
  const totalSeconds = Math.max(0, Math.floor(parseTimeSpan(value)))
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60

  return `${minutes}:${seconds.toString().padStart(2, '0')}`
}

export function formatDuration(start: string, end: string) {
  const seconds = Math.max(0, parseTimeSpan(end) - parseTimeSpan(start))
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = Math.round(seconds % 60)

  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
}

export function formatPercent(value: number) {
  return `${Math.round(value * 100)}%`
}

export function formatEnum(value: string) {
  return value
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
}

export function getTimelinePosition(start: string, end: string, totalDuration: number) {
  const startSeconds = parseTimeSpan(start)
  const duration = Math.max(0, parseTimeSpan(end) - startSeconds)
  const safeTotal = totalDuration > 0 ? totalDuration : 1

  return {
    left: `${(startSeconds / safeTotal) * 100}%`,
    width: `${Math.max(4, (duration / safeTotal) * 100)}%`,
  }
}

export function getAnalysisDuration<TTrack extends { sections: Array<{ end: string }> }>(tracks: TTrack[]) {
  return Math.max(
    0,
    ...tracks.flatMap((track) => track.sections.map((section) => parseTimeSpan(section.end))),
  )
}
